<template>
    <div class="products" data-aos="fade-right" :style="{
        position:top>height?'fixed':'absolute',
        top:top>height?'160px':'60px',
    }">
        <el-menu
          :defaultActive="defaultActive"
          class="el-menu-vertical-demo "
          @select="handleSelect"
          >
          <el-menu-item v-for="item,index in productsList" :index="item.src"
          >
              <span v-if="item.title !== 'logo'">{{item.title}}</span>
              <img :src="item.src" alt="" height="36px">
          </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    data(){
      return {
        productsList:[
            {
              title:'logo',
              src:require('@/assets/navLogo.png'),
            },
            {
              title:'医院合作案例',
              src:'/case/hospital'
            },
            {
              title:'科研机构合作案例',
              src:'/case/institution'
            },
            {
              title:'公司合作案例',
              src:'/case/company'
            }
        ],
        defaultActive:'/case/hospital',
        top:0,
        height:window.innerHeight + 100
      }
    },
    mounted() {
        // 监听滚动事件
        window.addEventListener('scroll', this.handleScroll, true)
        this.defaultActive = this.$route.path
    },
    methods:{
        handleScroll(){
          let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset)
          this.top = top
        },
        handleSelect(src){
            this.$emit('caseSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
.products{
    position: absolute;
    left: 10px;
    top: 60px;
    z-index: 999999;
    visibility: visible!important;
    .el-menu-vertical-demo{
        background: none;
        border-right: none;
        .el-menu-item{
            width: 340px;
            height: 65px;
            box-sizing: border-box;
            padding: 0;
            line-height: 65px;
            text-align: center;
            font-size: 18px;
            margin-bottom: 2px;
            background: #ededed;
            letter-spacing: 3px;
        }
        .el-menu-item:nth-child(1){
            cursor: auto;
            background: #ededed!important;
             opacity: 1;
        }
        .is-active{
            background: #ed1c25;
            border-left: 5px solid #a50006;
            span{
                color: #fff;
            }
        }
    }
}

</style>
